// PsyPractice — hukuki belgeler / Suomi.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir —
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Toiminimi";

const OWNER = 'PsyPractice (jäljempänä ”Alusta” tai ”Rekisterinpitäjä”)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Käyttöehdot ja vastuuvapauslauseke",
    description:
      "Palvelun luonne ja rajat, se mitä palvelu ei korvaa, käyttäjän sitoumukset sekä kattava vastuusta luopuminen, joka asettaa kaiken vastuun käyttäjälle.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Osapuolet ja hyväksyminen",
        paras: [
          `Nämä käyttöehdot solmitaan seuraavien osapuolten välillä: ${OWNER} sekä jokainen luonnollinen henkilö tai oikeushenkilö, joka pääsee Alustalle tai käyttää sitä (”Käyttäjä”). Luomalla tilin, kirjautumalla sisään tai käyttämällä Alustaa millä tahansa tavalla Käyttäjä vahvistaa lukeneensa ja ymmärtäneensä nämä ehdot sekä hyväksyvänsä ne ja sitoutuvansa niihin kokonaisuudessaan ja ehdoitta. Sen, joka ei hyväksy näitä ehtoja, ei tule käyttää Alustaa.`,
        ],
      },
      {
        heading: "2. Palvelun luonne ja rajat",
        bullets: [
          "PsyPractice on tekoälyavusteinen potilasSIMULAATIO-ohjelmisto, jonka avulla psykologian opiskelijat ja uransa alussa olevat kliinikot voivat toteuttaa ja tallentaa omaa haastatteluharjoitteluaan turvallisessa ympäristössä.",
          "PsyPractice ei ole koulutus- tai opetuspalvelu; se on ohjelmistotyökalu, jonka avulla käyttäjä toteuttaa ja tallentaa omaa harjoitteluaan. Alusta ei tarjoa oppitunteja, opinto-ohjelmaa, kokeita eikä todistuksia, eikä se anna minkäänlaista arvonimeä, pätevyyttä tai valtuutusta.",
          "Simuloitu ”potilas” ei ole oikea asiakas; sen vastaukset on syntetisoitu tekoälyllä, ne voivat olla virheellisiä, puutteellisia, epäjohdonmukaisia tai harhaanjohtavia, eikä niihin liity mitään väitettä kliinisestä oikeellisuudesta tai totuudenmukaisuudesta.",
        ],
      },
      {
        heading: "2.1. Mitä Alusta ei korvaa",
        bullets: [
          "Se EI ole oikeaa terapiaa tai ohjausta, eikä se korvaa yhtäkään oikean asiakkaan kanssa käytyä istuntoa.",
          "Se EI korvaa kliinistä työnohjausta. Tekoälytyönohjaajan tuottamat palauteraportit ovat automaattisesti luotua tekstiä; ne eivät ole asiantuntijalausunto, virallinen arvio eivätkä arvosana.",
          "Se EI ole diagnostinen, seulonta- tai arviointiväline; mitään Alustan tuotosta ei saa käyttää ketään oikeaa henkilöä koskevaan diagnostiseen tai kliiniseen päätöksentekoon.",
          "Sitä EI SAA käyttää kriisi- tai hätätilanteissa. Itsetuhoisten ajatusten, itselle tai muille aiheutuvan vahingon riskin tai vastaavan hätätilanteen kohdalla sulje Alusta ja ota välittömästi yhteyttä paikalliseen hätänumeroon tai toimivaltaiseen terveydenhuollon yksikköön.",
          "Se EI ole ammatillisen pätevyyden, laillistuksen, arvonimen tai toimivallan lähde; Alustalla käytettyä aikaa ja sen tuotoksia ei saa esittää millekään taholle pätevyyden osoituksena.",
        ],
      },
      {
        heading: "3. Käyttäjän vakuutukset ja sitoumukset",
        bullets: [
          "Käyttäjä sitoutuu käyttämään Alustaa yksinomaan lain ja eettisten sääntöjen rajoissa oman ammatillisen harjoittelunsa kehittämiseksi.",
          "Käyttäjä sitoutuu OLEMAAN syöttämättä kenenkään OIKEAN potilaan tai asiakkaan tietoja, tunnistetietoja tai erityisiin henkilötietoryhmiin kuuluvia terveystietoja; kaikki tästä aiheutuvat oikeudelliset seuraukset kuuluvat yksinomaan Käyttäjälle.",
          "Käyttäjä sitoutuu olemaan käyttämättä mitään Alustalta saatua tuotosta kenenkään oikean henkilön diagnosointiin, hoitoon, interventioon tai kliiniseen päätöksentekoon.",
          "Käyttäjä vastaa yksin omasta ammatillisesta pätevyydestään, toimivaltansa laajuudesta sekä sovellettavien ammatillisten ja eettisten sääntöjen noudattamisesta.",
          "Tilin turvallisuus, salasanan salassapito ja kaikki Käyttäjän tilillä tehdyt toimet ovat Käyttäjän vastuulla.",
          "Tili on henkilökohtainen; Käyttäjä sitoutuu olemaan jakamatta sitä muiden kanssa ja olemaan käyttämättä Alustaa automatisoiduin keinoin (botit, skriptit tms.). Maksullisten tilausten käyttöä koskee kohtuullisen käytön raja (tällä hetkellä 60 istuntoa kalenterikuukaudessa), josta säädetään tarkemmin etämyyntisopimuksessa.",
        ],
      },
      {
        heading: "4. Kaikki vastuu on Käyttäjällä (vastuusta luopuminen)",
        paras: [
          "Alusta tarjotaan ”SELLAISENAAN” ja ”SITEN KUIN SE ON SAATAVILLA”, ilman minkäänlaista nimenomaista tai hiljaista takuuta (mukaan lukien keskeytymätön toiminta, virheettömyys, soveltuvuus tiettyyn tarkoitukseen, oikeellisuus tai ajantasaisuus).",
          "Käyttäjä hyväksyy ja sitoutuu siihen, että hän on YKSIN ja HENKILÖKOHTAISESTI vastuussa kaikista välittömistä, välillisistä, satunnaisista, erityisistä tai seurannaisvahingoista (mukaan lukien aineelliset vahingot, henkinen kärsimys, ammatilliseen maineeseen kohdistuvat vahingot, tietojen menetys, tulonmenetys ja kolmansille aiheutuneet vahingot), jotka johtuvat Alustan käytöstä tai käytön estymisestä, tekoälyn tuotoksiin luottamisesta tai näiden tuotosten soveltamisesta millä tahansa tavalla.",
          "Sovellettavan lain sallimissa rajoissa Käyttäjä LUOPUU täten peruuttamattomasti ja ehdoitta — nyt ja etukäteen — kaikista vaatimuksista, kanteista ja korvausoikeuksista, joita hän voisi esittää Alustaa, sen omistajia, työntekijöitä, kehittäjiä, yhteistyökumppaneita ja palveluntarjoajia kohtaan sellaisen vahingon johdosta, joka hänelle mahdollisesti aiheutuu haitallisen lopputuloksen sattuessa.",
          "Lisäksi Käyttäjä sitoutuu pitämään Alustan täysin vahingoittumattomana kaikista vaatimuksista, vahingoista, seuraamuksista ja kuluista (mukaan lukien asianajokulut), jos Alustaan otetaan yhteyttä kolmannen osapuolen tai laitoksen toimesta Käyttäjän oman virheen, huolimattomuuden tai näiden ehtojen vastaisen käytön vuoksi.",
        ],
      },
      {
        heading: "5. Vastuunrajoitus",
        paras: [
          "Sovellettavan lain pakottavia säännöksiä rajoittamatta Alustan kokonaisvastuu rajoittuu joka tapauksessa siihen määrään, jonka Käyttäjä on tosiasiallisesti maksanut Alustalle vaatimuksen perusteena olevaa tapahtumaa edeltäneiden 12 kuukauden aikana. Maksuttomassa käytössä tämä määrä on nolla.",
        ],
      },
      {
        heading: "6. Immateriaalioikeudet, muutokset ja päättäminen",
        bullets: [
          "Kaikki Alustaan, sen ohjelmistoon, ulkoasuun, potilastapausmalleihin ja sisältöön liittyvät immateriaalioikeudet kuuluvat Alustalle.",
          "Kaikki siirrettävissä olevat taloudelliset immateriaalioikeudet sisältöön, jonka Käyttäjä luo Alustalla (mukaan lukien hänen kirjoittamansa terapeutin viestit, istuntojen transkriptit ja niistä johdetut aineistot), katsotaan luovutetuiksi Alustalle yksinomaisesti, ikuisesti ja rojaltivapaasti sillä hetkellä, kun sisältö luodaan; Alusta voi käyttää, kopioida ja käsitellä tätä sisältöä maailmanlaajuisesti ja rajoituksetta mihin tahansa tarkoitukseen, mukaan lukien palvelun ylläpito, palautteen tuottaminen sekä järjestelmän parantaminen ja kehittäminen (mukaan lukien koneoppimiseen perustuva kehitys). Tämä luovutus ei vaikuta Käyttäjän tietosuojalainsäädännön (GDPR / KVKK) mukaisiin henkilötietoja koskeviin oikeuksiin, jotka pysyvät voimassa.",
          "Alusta pidättää oikeuden muuttaa, keskeyttää tai lopettaa nämä ehdot ja palvelun laajuuden milloin tahansa ilman ennakkoilmoitusta.",
          "Näiden ehtojen rikkomistapauksessa Alusta voi keskeyttää tai sulkea tilin ilman ennakkoilmoitusta.",
        ],
      },
      {
        heading: "7. Sovellettava laki ja toimivaltainen tuomioistuin",
        paras: [
          "Näihin ehtoihin sovelletaan Turkin tasavallan lakia. Mahdollisissa riita-asioissa toimivaltaisia ovat Turkin tasavallan tuomioistuimet ja ulosottoviranomaiset.",
          "Euroopan unionissa asuvien kuluttajien osalta pidätetään heidän asuinmaansa pakottavien kuluttajansuojasäännösten antama suoja sekä heidän GDPR:n mukaiset tietosuojaoikeutensa; tämä lainvalinta ei syrjäytä näitä pakottavia säännöksiä.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Tietosuojakäytäntö",
    description:
      "GDPR perustasona; käsiteltävät tiedot, oikeusperusteet, palvelinsijainti EU:ssa, kansainväliset siirrot (tekoälypalveluntarjoaja) sekä KVKK:n 9 §:n mukainen ulkomaille siirtoa koskeva lauseke Turkissa oleville käyttäjille.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Tässä tietosuojakäytännössä kuvataan, miten henkilötietoja käsitellään Alustalla, jota ylläpitää ${OWNER}. Tietosuojan perustasona käytäntö noudattaa EU:n yleistä tietosuoja-asetusta (GDPR / 2016/679); Turkissa oleviin käyttäjiin sovelletaan lisäksi Turkin henkilötietojen suojaa koskevaa lakia nro 6698 (KVKK) — erityisesti sen ulkomaille siirtoa koskevaa 9 §:ää. KVKK-tietosuojailmoitus ja nimenomaista suostumusta koskeva seloste ovat tämän käytännön erottamattomia osia.`,
        ],
      },
      {
        heading: "Rekisterinpitäjä ja palvelinsijainti",
        bullets: [
          "Rekisterinpitäjä: PsyPractice. Rekisteröityjen pyynnöt käsitellään Alustalla ilmoitetun yhteyskanavan kautta (yhteyssähköposti: info@psycora.com).",
          "Palvelinsijainti: Alusta ja sen tietokanta sijaitsevat Euroopan unionin alueella, konesalissa Alankomaissa (Oracle Cloud). EU:ssa ja ETA-alueella olevien käyttäjien tietoja käsitellään ja säilytetään EU:ssa.",
          "Palvelintarjoaja toimii yksinomaan henkilötietojen käsittelijänä solmitun tietojenkäsittelysopimuksen (DPA) nojalla.",
        ],
      },
      {
        heading: "Kerättävät tiedot",
        bullets: [
          "Tilitiedot: nimi, sähköposti, tiivistetty salasana, tilaus- ja tasotiedot.",
          "Käyttötiedot: luodut istunnot, istuntojen transkriptit, luodut potilastapaukset, työnohjaajan palauteraportit.",
          "Tekniset tiedot: istuntotiedot, IP-osoite, selain- ja kieliasetus, käyttörajoitus- ja tietoturvalokit.",
        ],
      },
      {
        heading: "Käsittelyn tarkoitukset ja oikeusperuste (GDPR 6 artikla)",
        bullets: [
          "Sopimuksen täyttäminen (6 art. 1 kohta b): tilin luominen, istuntojen käyminen, istuntojen yli kantava potilasmuisti, työnohjaajan arvio, tilausten ja käyttörajojen hallinta.",
          "Oikeutettu etu (6 art. 1 kohta f): tietoturva, väärinkäytösten estäminen, järjestelmän parantaminen ja virheiden selvittäminen.",
          "Lakisääteinen velvoite (6 art. 1 kohta c): lainsäädännöstä johtuva säilyttäminen ja raportointi.",
          "Suostumus (6 art. 1 kohta a): analytiikka ja tuotekehitykseen liittyvä käsittely, joka ei ole palvelun kannalta välttämätöntä, sekä tarvittaessa siirto EU:n ja ETA-alueen ulkopuolelle.",
        ],
      },
      {
        heading: "Kansainväliset siirrot",
        paras: [
          "Koska palvelimet sijaitsevat EU:ssa (Alankomaat), EU- ja ETA-käyttäjien tietoja käsitellään pääsääntöisesti EU:ssa ilman siirtoa kolmanteen maahan tällä tasolla. Tekoälyvastausten tuottamiseksi istuntojen sisältö ja kehotteet välitetään kuitenkin tekoälypalveluntarjoajalle (Anthropic), jonka käsittelyinfrastruktuuri voi sijaita EU:n ja ETA-alueen ulkopuolella (esimerkiksi Yhdysvalloissa).",
          "Tällaiset EU:n ja ETA-alueen ulkopuolelle tehtävät siirrot perustuvat GDPR:n 44 artiklan ja sitä seuraavien artiklojen mukaisiin asianmukaisiin suojatoimiin — erityisesti Euroopan komission vakiosopimuslausekkeisiin (SCC) — ja palveluntarjoajan kanssa on solmittu tietojenkäsittelysopimus (DPA). Alusta EI myy henkilötietoja markkinointitarkoituksiin; tietoja ei luovuteta kolmansille osapuolille muutoin kuin siltä osin kuin se on ehdottoman välttämätöntä palvelun toteuttamiseksi (toimivaltaisten viranomaisten lainmukaiset pyynnöt pidätetään).",
        ],
      },
      {
        heading: "Turkissa oleville käyttäjille — KVKK 9 § (siirto ulkomaille)",
        paras: [
          "Turkissa olevien käyttäjien henkilötietoja siirretään Turkin ulkopuolelle, koska palvelimet sijaitsevat Alankomaissa (EU), ja niitä voidaan siirtää myös Anthropicille tekoälykäsittelyä varten. Nämä siirrot kuuluvat KVKK:n 9 §:n soveltamisalaan ja perustuvat asianmukaisiin suojatoimiin (viranomaisen julkaisema vakiosopimus tai sitoumus) tai tarvittaessa nimenomaiseen suostumukseesi. Siirron laajuus, vastaanottajat ja tarkoitus on kuvattu yksityiskohtaisesti KVKK-tietosuojailmoituksessa ja nimenomaista suostumusta koskevassa selosteessa.",
        ],
      },
      {
        heading: "Rekisteröidyn oikeudet (GDPR 15–22 artikla)",
        bullets: [
          "Oikeus saada pääsy tietoihin, oikaista ne, poistaa ne (”oikeus tulla unohdetuksi”) ja rajoittaa käsittelyä.",
          "Oikeus siirtää tiedot järjestelmästä toiseen: saada antamasi tiedot jäsennellyssä, yleisesti käytetyssä ja koneellisesti luettavassa muodossa.",
          "Vastustamisoikeus: oikeutettuun etuun perustuvan käsittelyn ja suoramarkkinoinnin vastustaminen.",
          "Oikeudet, jotka koskevat pelkästään automaattiseen käsittelyyn perustuvaa päätöksentekoa ja profilointia.",
          "Oikeus peruuttaa suostumus milloin tahansa suostumukseen perustuvassa käsittelyssä (peruuttaminen ei vaikuta sitä edeltäneen käsittelyn lainmukaisuuteen).",
          "Oikeus tehdä valitus valvontaviranomaiselle: EU:ssa asianomaiselle tietosuojaviranomaiselle, Turkissa henkilötietojen suojaviranomaiselle (KVKK).",
        ],
      },
      {
        heading: "Säilytys ja tietoturva",
        bullets: [
          "Tietoja säilytetään niin kauan kuin käsittelyn tarkoitus edellyttää ja lainsäädännön määräämien määräaikojen ajan; määräajan päätyttyä ne poistetaan tai anonymisoidaan.",
          "Arkaluonteiset kentät (esimerkiksi salasana sekä vahvistus- ja palautuskoodit) säilytetään salattuina tai tiivisteinä; pääsy niihin on oikeusperusteista.",
          "Koska mikään tiedonsiirto- tai tallennustapa ei ole 100-prosenttisen turvallinen, täydellistä turvallisuutta ei voida taata.",
        ],
      },
      {
        heading: "Oikeiden potilastietojen kielto",
        paras: [
          "Alusta on simulaatio-ohjelmisto; oikeiden asiakkaiden henkilö- tai terveystietojen syöttäminen on kielletty. Kaikki vastuu, joka aiheutuu siitä, että Käyttäjä syöttää tietoja tämän kiellon vastaisesti, kuuluu yksinomaan Käyttäjälle.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK-tietosuojailmoitus",
    description:
      "Rekisterinpitäjä, käsittelyn tarkoitukset, oikeusperuste, siirrot ja rekisteröidyn oikeudet lain nro 6698 10 §:n mukaisesti.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Rekisterinpitäjä",
        paras: [
          `Turkin henkilötietojen suojaa koskevan lain nro 6698 (”KVKK”) 10 §:n nojalla henkilötietojasi käsittelee rekisterinpitäjänä ${OWNER} jäljempänä kuvatussa laajuudessa.`,
        ],
      },
      {
        heading: "Käsiteltävät tiedot ja tarkoitukset",
        bullets: [
          "Henkilö- ja yhteystiedot (nimi, sähköposti): tilin luominen, tunnistautuminen, viestintä.",
          "Asiakastapahtumat (tilaus, taso, käyttö): palvelun toteuttaminen, laskutus, rajojen valvonta.",
          "Tapahtumien turvallisuus (istunto, IP, lokit): tietoturva, väärinkäytösten estäminen, lakisääteinen velvoite.",
          "Käyttäjän sisältö (istuntojen transkriptit, luodut tapaukset): ohjelmistopalvelun toteuttaminen ja palautteen tuottaminen.",
          "Organisaation ryhmäjäsenyys (ryhmätunniste, jäsenyyden kesto): kun käyttäjä liittyy organisaation järjestämään ryhmään, ohjaajan näkyvyys ja ryhmän hallinnointi.",
        ],
      },
      {
        heading: "Oikeusperuste (5 §)",
        bullets: [
          "Sopimuksen tekeminen ja täyttäminen: palvelun tuottamiseksi välttämättömät tiedot.",
          "Rekisterinpitäjän oikeutettu etu: tietoturva, petosten estäminen, järjestelmän parantaminen.",
          "Lakisääteinen velvoite: lainsäädännöstä johtuva säilyttäminen ja raportointi.",
          "Nimenomainen suostumus: siirto ulkomaille (9 §) ja muu käsittely, joka ei ole palvelun kannalta välttämätöntä.",
        ],
      },
      {
        heading: "Siirto ulkomaille (9 §)",
        paras: [
          "Koska Alusta ja sen tietokanta sijaitsevat Euroopan unionin alueella, konesalissa Alankomaissa (Oracle Cloud), Turkissa olevien käyttäjien henkilötietoja siirretään Turkin ulkopuolelle (EU:hun). Lisäksi tekoälyvastausten tuottamiseksi istuntojen sisältöä ja kehotteita voidaan siirtää tekoälypalveluntarjoajalle (Anthropic), jonka käsittelyinfrastruktuuri voi sijaita EU:n ja ETA-alueen ulkopuolella (esimerkiksi Yhdysvalloissa).",
          "Nämä ulkomaille tehtävät siirrot kuuluvat KVKK:n 9 §:n soveltamisalaan ja perustuvat asianmukaisiin suojatoimiin, kuten viranomaisen julkaisemaan vakiosopimukseen tai sitoumukseen, tai tarvittaessa nimenomaiseen suostumukseesi. Palvelin- ja palveluntarjoajien kanssa on solmittu tietojenkäsittelysopimukset (DPA).",
        ],
      },
      {
        heading: "Organisaatioryhmät ja ohjaajan näkyvyys",
        paras: [
          "Jos liityt yliopiston, klinikan tai vastaavan organisaation avaamaan ryhmään, kyseisen ryhmän ohjaaja voi nähdä istuntojesi sisällön (transkriptit) ja työnohjausraportit ryhmän keston ajan. Tämä näkyvyys koskee vain ryhmään liittyviä istuntojasi ja päättyy, kun ryhmäjäsenyytesi päättyy.",
          "Tämä pääsy hankitaan ERILLISELTÄ nimenomaisen suostumuksen näytöltä, joka esitetään ryhmään liittyessäsi; se ei sisälly Alustan yleiseen hyväksyntään. Jos et anna kyseistä suostumusta, et voi liittyä ryhmään, mutta voit jatkaa Alustan käyttöä yksin täsmälleen kuten ennenkin. Suostumuksen peruuttaminen päättää ryhmäjäsenyytesi eikä vaikuta yksilölliseen käyttöösi.",
        ],
      },
      {
        heading: "Rekisteröidyn oikeudet (11 §)",
        bullets: [
          "Saada tietää, käsitelläänkö henkilötietojasi, ja jos käsitellään, pyytää niistä tietoa.",
          "Saada tietää käsittelyn tarkoitus ja se, käytetäänkö tietoja tarkoituksen mukaisesti.",
          "Tietää kolmannet osapuolet, joille tietoja siirretään kotimaassa tai ulkomailla.",
          "Pyytää puutteellisen tai virheellisen käsittelyn oikaisemista ja edellytysten täyttyessä tietojen poistamista tai hävittämistä.",
          "Vastustaa sinulle epäedullista tulosta, joka syntyy pelkästään automaattisen analyysin perusteella.",
          "Vaatia korvausta vahingosta, joka on aiheutunut lainvastaisesta käsittelystä.",
        ],
      },
      {
        heading: "Hakemukset",
        paras: [
          "Voit esittää oikeuksiasi koskevat pyynnöt rekisterinpitäjän ilmoittaman yhteyskanavan kautta. Hakemukset käsitellään KVKK:ssa ja sen nojalla annetussa alemmanasteisessa sääntelyssä määrätyissä määräajoissa.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Nimenomaista suostumusta koskeva seloste",
    description:
      "Tietosuojailmoituksesta erillinen; vapaaehtoisesti annettu suostumus siirtoon ulkomaille ja tekoälykäsittelyyn.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Vakuutan lukeneeni ja ymmärtäneeni KVKK-tietosuojailmoituksen ja annan vapaaehtoisesti, tietoisesti ja nimenomaisesti suostumukseni jäljempänä kuvattuun käsittelyyn. (KVKK-viranomaisen päätöksen nro 2018/90 mukaisesti nimenomainen suostumus hankitaan erillään tiedonantovelvollisuudesta.)",
        ],
      },
      {
        heading: "Suostumuksen kohteena oleva käsittely",
        bullets: [
          "Henkilötietojeni siirto Turkin ulkopuolelle sekä niiden säilyttäminen ja käsittely siellä, koska Alustan palvelimet sijaitsevat Euroopan unionissa (Alankomaat / Oracle Cloud) (KVKK 9 §).",
          "Istuntojeni transkriptien ja kehotteiden siirto tekoälypalveluntarjoajalle (Anthropic), jonka käsittelyinfrastruktuuri voi sijaita EU:n ja ETA-alueen ulkopuolella, ja niiden käsittely siellä tekoälyvastausten tuottamiseksi (KVKK 9 §).",
          "Käsittely tuotekehitystä ja analytiikkaa varten silloin, kun se ei ole palvelun tuottamisen kannalta välttämätöntä.",
          "Palveluun liittyvien ilmoitusten vastaanottaminen.",
        ],
      },
      {
        heading: "Suostumuksen peruuttaminen",
        paras: [
          "Ymmärrän, että voin peruuttaa nimenomaisen suostumukseni milloin tahansa; koska siirto ulkomaille tekoälypalveluntarjoajalle on kuitenkin teknisesti välttämätöntä palvelun toiminnalle, hyväksyn, että tämän suostumuksen peruuttaminen voi johtaa siihen, etten voi käyttää kyseisiä ominaisuuksia tai koko palvelua. Peruuttaminen ei vaikuta peruuttamispäivään mennessä tehdyn käsittelyn lainmukaisuuteen.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice — see the comment there.
    id: "outreach",
    title: "Yhteydenottoviestintää koskeva ilmoitus",
    description:
      "Akateemisille ja organisaatioiden yhteyshenkilöille, jotka ovat saaneet yritysviestin: mistä tiedot ovat peräisin, miksi niitä käsitellään, mikä on oikeusperuste ja miten viestit voi kieltää.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Tämä ilmoitus annetaan niille, jotka ovat vastaanottaneet PsyPractice-palvelun yliopistojen psykologian laitoksille ja niiden akateemiselle henkilökunnalle lähettämän yritysviestin, Turkin henkilötietojen suojaa koskevan lain nro 6698 (KVKK) 10 §:n ja tiedonantovelvollisuuden täyttämisen menettelyjä ja periaatteita koskevan tiedonannon mukaisesti. Koska henkilötietojasi ei ole saatu suoraan sinulta, ilmoitus annetaan viimeistään ensimmäisen yhteydenoton yhteydessä, minkä vuoksi viestissä on linkki tähän ilmoitukseen.",
        ],
      },
      {
        heading: "1. Rekisterinpitäjä",
        bullets: [
          `Nimi: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Osoite: ${MERCHANT.addressEn}`,
          `Verotoimisto / verotunnus: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Sähköposti: ${MERCHANT.email}`,
          `Verkkosivu: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Käsiteltävät tiedot ja niiden lähde",
        paras: [
          "Käsittely rajoittuu ammatillisiin yhteystietoihin: nimi, akateeminen arvo, yliopisto ja laitos, organisaation sähköpostiosoite sekä julkaistuna organisaation puhelinnumero.",
          "Näitä tietoja ei ole kerätty sinulta, vaan ne on koottu yliopistojen julkisesti julkaisemilta virallisilta laitos- ja tiedekuntasivuilta. Erityisiin henkilötietoryhmiin kuuluvia tietoja ei käsitellä, eikä yksityisiä (muita kuin organisaation) sähköpostiosoitteita käytetä yhteydenottoihin.",
        ],
      },
      {
        heading: "3. Tarkoitus",
        paras: [
          "Tietojasi käsitellään psykologian opiskelijoille ja kliinikoille suunnatun ohjelmistotyökalun esittelemiseksi, laitoksesi kutsumiseksi mahdolliseen pilotti- tai yhteistyökeskusteluun sekä siihen liittyvän kirjeenvaihdon hoitamiseksi. Tietoja ei käytetä mihinkään muuhun tarkoitukseen, niitä ei myydä eikä siirretä kolmansille osapuolille markkinointia varten.",
        ],
      },
      {
        heading: "4. Oikeusperuste",
        paras: [
          "Käsittely perustuu KVKK:n 5 §:n 2 momentin f kohdan mukaiseen rekisterinpitäjän oikeutettuun etuun edellyttäen, ettei se loukkaa perusoikeuksiasi ja -vapauksiasi: yhteyttä otetaan vain organisaation osoitteeseen, vain vastaanottajan ammatillisesti suoraan liittyvässä asiassa ja rajoitetun määrän kertoja.",
          "Pelkkä tietojen julkinen saatavuus verkossa ei sinänsä ole oikeusperuste. Henkilötietojen suojaviranomainen on katsonut, ettei tietojen julkisuus tee niistä käytettäviä mihin tahansa tarkoitukseen ja että julkiseksi saattamisen tarkoitus on arvioitava erikseen; 5 §:n 2 momentin d kohtaan ei siksi vedota.",
        ],
      },
      {
        heading: "5. Siirrot ja säilytys",
        paras: [
          "Kirjeenvaihto hoidetaan sähköpostipalvelun kautta, jonka infrastruktuuri voi sijaita ulkomailla; tällaiset siirrot tehdään KVKK:n 9 §:n mukaisin asianmukaisin suojatoimin.",
          "Tietosi poistetaan, kun yhteydenoton tarkoitus päättyy tai kun sitä pyydät. Poistopyynnön jälkeen säilytetään ainoastaan tarkasti rajattu ”ei yhteydenottoja” -merkintä sen varmistamiseksi, ettei sinuun oteta uudelleen yhteyttä; sitä ei koskaan käytetä yhteydenottoihin.",
        ],
      },
      {
        heading: "6. Kaupalliset sähköiset viestit ja kieltäytymisoikeus",
        paras: [
          "Markkinointiviestit kuuluvat sähköisen kaupankäynnin sääntelystä annetun lain nro 6563 soveltamisalaan. Voit kieltäytyä niiden vastaanottamisesta syytä ilmoittamatta; kieltäytymiset käsitellään viimeistään kolmen arkipäivän kuluessa, minkä jälkeen markkinointiviestejä ei enää lähetetä. Riittää, että vastaat saamaasi viestiin tai kirjoitat osoitteeseen " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Oikeutesi",
        paras: [
          "KVKK:n 11 §:n nojalla sinulla on oikeus saada tietää, käsitelläänkö henkilötietojasi, pyytää niistä tietoa, saada tietää käsittelyn tarkoitus ja se, käytetäänkö tietoja tarkoituksen mukaisesti, tietää kolmannet osapuolet, joille tietoja siirretään Turkissa tai ulkomailla, pyytää puutteellisten tai virheellisten tietojen oikaisemista, pyytää niiden poistamista tai hävittämistä, pyytää näiden toimien ilmoittamista kolmansille osapuolille, vastustaa sinulle epäedullista tulosta, joka syntyy pelkästään automaattisen analyysin perusteella, sekä vaatia korvausta aiheutuneesta vahingosta.",
          `Pyynnöt voi lähettää osoitteeseen ${MERCHANT.email}, ja niihin vastataan viimeistään kolmenkymmenen päivän kuluessa. Sinulla on lisäksi oikeus tehdä valitus henkilötietojen suojaviranomaiselle.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Evästekäytäntö",
    description: "Käytettävien evästeiden tyypit, niiden tarkoitukset ja asetusten hallinta.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Alusta käyttää evästeitä ja vastaavia paikallisen tallennuksen tekniikoita (localStorage) istuntosi ylläpitämiseen ja asetustesi muistamiseen.",
        ],
      },
      {
        heading: "Käytettävät tekniikat",
        bullets: [
          "Ehdottoman välttämättömät: istunto- ja tunnistautumistunniste, tietoturva. Palvelu ei toimi ilman näitä.",
          "Toiminnalliset: kieli- ja alueasetus (NEXT_LOCALE), käyttöliittymän asetukset (esimerkiksi teema).",
          "Suorituskyky ja tietoturva: tekniset lokit käyttörajoituksia ja väärinkäytösten havaitsemista varten.",
        ],
      },
      {
        heading: "Asetusten hallinta",
        paras: [
          "Voit poistaa tai estää evästeitä selaimessasi; ehdottoman välttämättömien evästeiden estäminen kuitenkin estää sisäänkirjautumisen ja keskeiset toiminnot. GDPR:n ja ePrivacy-periaatteiden sekä KVKK:n evästeoppaan mukaisesti muita kuin välttämättömiä evästeitä käytetään vain nimenomaisen valintasi tai suostumuksesi perusteella.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Tietoa meistä",
    description:
      "PsyPractice-palvelun tarkoitus, tarjottava palvelu sekä myyjän yhteystiedot.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice on tekoälyavusteinen potilassimulaatio- ja kliinisten taitojen alusta, joka on rakennettu psykologian opiskelijoille ja vastavalmistuneille, uransa alussa oleville kliinikoille. Käyttäjät käyvät tekstipohjaisia terapiaistuntoja; jokaisen istunnon päätteeksi tekoälytyönohjaaja arvioi keskustelun ja tuottaa kehittävän palauteraportin. Potilastekoäly kantaa terapeuttista suhdetta eteenpäin istunnosta toiseen istuntojen yli kantavan muistin avulla.",
        ],
      },
      {
        heading: "Tehtävämme",
        paras: [
          "Tavoitteemme on antaa tulevaisuuden mielenterveysalan ammattilaisille turvallinen ja toistettava ympäristö, jossa harjoitella haastattelutaitoja ilman riskiä vahingoittaa oikeita asiakkaita. PsyPractice ei ole koulutus- tai opetuspalvelu; se on ohjelmistotyökalu, jonka avulla käyttäjä toteuttaa ja tallentaa omaa harjoitteluaan. Se ei ole oikeaa terapiaa tai ohjausta, se ei korvaa kliinistä työnohjausta, se ei ole diagnostinen tai arviointiväline, eikä sitä saa käyttää kriisi- tai hätätilanteissa.",
        ],
      },
      {
        heading: "Mitä tarjoamme",
        bullets: [
          "Tekstipohjaisia terapiaistuntojen simulaatioita monenlaisilla potilasprofiileilla, jotka on syntetisoitu kliinisestä kirjallisuudesta.",
          "Automaattiset työnohjausraportit jokaisen istunnon jälkeen.",
          "”Elävän potilaan” malli, jossa istuntojen yli kantava muisti kehittää terapeuttista suhdetta ajan myötä.",
          "Omien potilaiden luonti, jonka avulla opiskelijat voivat luoda omia tekoälytapauksiaan.",
          "Kehitysmittarit, jotka seuraavat mikrotaitojen kehittymistä.",
        ],
      },
      {
        heading: "Myyjän ja yrityksen tiedot",
        bullets: [
          `Toiminimi: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Osoite: ${MERCHANT.addressEn}`,
          `Verotoimisto / verotunnus: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Sähköposti: ${MERCHANT.email}`,
          `Verkkosivu: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Etämyyntisopimus",
    description:
      "Myyjää, ostajaa, palvelua, hintaa, maksamista, suoritusta ja peruuttamisoikeutta koskevat ehdot Turkin lain nro 6502 ja etäsopimusasetuksen mukaisesti.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Osapuolet",
        bullets: [
          `MYYJÄ: ${MERCHANT.legalName} (${OWNER_TYPE}). Osoite: ${MERCHANT.addressEn}. Verotoimisto / verotunnus: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. Sähköposti: ${MERCHANT.email}.`,
          "OSTAJA: luonnollinen henkilö tai oikeushenkilö, joka luo tilin Alustalle ja ostaa maksullisen tilauksen (”Ostaja”).",
        ],
      },
      {
        heading: "2. Sopimuksen kohde",
        paras: [
          "Tämän sopimuksen kohteena on määrittää osapuolten oikeudet ja velvollisuudet Turkin kuluttajansuojalain nro 6502 ja etäsopimusasetuksen mukaisesti sen digitaalisen palvelutilauksen myynnin ja suorituksen osalta, jonka Ostaja ostaa sähköisesti Alustan kautta ja jonka ominaisuudet ja myyntihinta on esitetty jäljempänä.",
        ],
      },
      {
        heading: "3. Palvelun luonne ja hinta",
        bullets: [
          "Myytävä palvelu koostuu PsyPractice-ohjelmiston maksullisen tilaustason tarjoamista tekoälyavusteisista potilassimulaatio-ominaisuuksista (digitaalinen palvelu / ohjelmiston käyttöoikeus).",
          "PsyPractice ei ole koulutus- tai opetuspalvelu; se on ohjelmistotyökalu, jonka avulla käyttäjä toteuttaa ja tallentaa omaa harjoitteluaan. Tilausmaksu on vastike kyseisen ohjelmiston käyttöoikeudesta; se ei ole maksu oppitunneista, opinto-ohjelmasta, kokeista, konsultoinnista tai mistään todistuksesta.",
          "Tilauksen sisältö, kesto (kuukausittain, 4 kuukauden jakso tai vuosittain) ja voimassa oleva hinta näytetään selvästi Alustan hinnasto-/maksusivulla ostohetkellä; verot sisältävä kokonaissumma ilmoitetaan Ostajalle ennen maksua.",
          "Hinnat ovat voimassa Alustalla näytettävässä valuutassa; ellei tilausta peruuteta, se uusiutuu automaattisesti samaan hintaan valitun jakson päättyessä.",
          "Tilauksissa, joita tarjotaan ”rajattomina istuntoina”, käyttöä koskee kohtuullisen käytön raja (tällä hetkellä 60 istuntoa kalenterikuukaudessa). Kun raja on saavutettu, uusia istuntoja voi taas aloittaa seuraavan kalenterikuukauden ensimmäisestä päivästä alkaen; tämä ei oikeuta hinnanalennukseen eikä hyvitykseen. Rajan tarkoitus on estää tilin jakaminen ja automatisoitu käyttö, eikä Myyjä muuta sitä Ostajan vahingoksi maksetun tilausjakson aikana.",
        ],
      },
      {
        heading: "4. Maksaminen",
        paras: [
          "Maksut peritään turvallisesti luotto- tai pankkikortilla toimiluvan saaneen maksulaitoksen iyzicon kautta. Myyjä ei tallenna korttitietoja; maksu käsitellään iyzicon suojatuissa järjestelmissä. Toistuvissa (tilaus)maksuissa summa veloitetaan automaattisesti jokaisella uusiutumisjaksolla Ostajan hyväksymältä kortilta.",
        ],
      },
      {
        heading: "5. Suoritus ja toimitus",
        paras: [
          "Palvelu on digitaalinen eikä siihen liity fyysistä toimitusta. Kun maksu on vahvistettu, tilauksen ominaisuudet ovat välittömästi käytettävissä Ostajan tilillä. Suoritus tapahtuu sähköisesti tarjoamalla keskeytymätön pääsy koko tilausjakson ajan.",
        ],
      },
      {
        heading: "6. Peruuttamisoikeus ja sen poikkeus",
        bullets: [
          "Etäsopimusasetuksen 15 §:n 1 momentin ğ kohdan nojalla peruuttamisoikeutta ei voi käyttää aineettomiin (digitaalisiin) hyödykkeisiin tai palveluihin, jotka suoritetaan välittömästi sähköisessä muodossa ja joiden suoritus on aloitettu Ostajan suostumuksella.",
          "Ostaja hyväksyy ostohetkellä, että palvelu suoritetaan välittömästi ja ettei peruuttamisoikeutta siksi ole. Ostaja voi peruuttaa tilauksen milloin tahansa lopettaakseen uusiutumisen; peruutus tulee voimaan kuluvan maksetun jakson päättyessä.",
          "Yksityiskohtaiset palautusehdot on esitetty kohdassa ”Toimitus- ja palautusehdot”.",
        ],
      },
      {
        heading: "7. Riidat ja voimaantulo",
        paras: [
          "Riitatilanteessa Ostaja voi kääntyä asuinpaikkansa kuluttajariitalautakunnan tai kuluttajatuomioistuimen puoleen kauppaministeriön ilmoittamien rahamääräisten rajojen puitteissa. Tämä sopimus syntyy ja tulee voimaan, kun Ostaja hyväksyy sen sähköisessä muodossa.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Toimitus- ja palautusehdot",
    description:
      "Digitaalisen palvelun toimitus, tilauksen peruuttaminen, peruuttamisoikeuden poikkeus ja hyvityksen ehdot.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Toimitus (digitaalinen palvelu)",
        bullets: [
          "PsyPractice on täysin digitaalinen palvelu; fyysistä tuotetta ei lähetetä eikä toimiteta kuriirilla.",
          "Heti kun maksu on vahvistettu, tilauksen ominaisuudet aktivoituvat automaattisesti ja välittömästi Ostajan tilillä; erillistä toimitusaikaa tai toimitusmaksua ei ole.",
          "Palvelua käytetään minkä tahansa internetiin yhteydessä olevan laitteen verkkoselaimella.",
        ],
      },
      {
        heading: "Tilauksen peruuttaminen",
        bullets: [
          "Ostaja voi peruuttaa tilauksen milloin tahansa tilin asetuksista. Peruutus tulee voimaan kuluvan maksetun jakson päättyessä ja pysäyttää seuraavan automaattisen uusiutumisen.",
          "Peruutuksen jälkeen pääsy palveluun jatkuu maksetun jakson loppuun asti.",
        ],
      },
      {
        heading: "Peruuttamisoikeus ja hyvitys",
        bullets: [
          "Koska kyseessä on digitaalinen palvelu, joka suoritetaan välittömästi Ostajan suostumuksella, peruuttamisoikeutta — eikä siten hyvitysoikeutta — ei pääsääntöisesti synny etäsopimusasetuksen 15 §:n 1 momentin ğ kohdan nojalla.",
          "Selkeissä virhetilanteissa, kuten virheellinen tai kahteen kertaan tehty veloitus tai palvelun täydellinen käyttökelvottomuus teknisistä syistä, Ostaja voi pyytää hyvitystä ottamalla yhteyttä Myyjään kohtuullisessa ajassa maksupäivästä.",
          `Hyvityspyynnöt lähetetään osoitteeseen ${MERCHANT.email}; hyväksytyt hyvitykset palautetaan maksussa käytetylle kortille iyzicon järjestelmän kautta pääsääntöisesti 14 päivän kuluessa. Hyvityksen kesto voi vaihdella pankin käsittelyajan mukaan.`,
        ],
      },
      {
        heading: "Yhteystiedot",
        paras: [
          `Kaikissa toimitusta, peruutusta ja hyvitystä koskevissa asioissa: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
